
import React from 'react';
import { ImageLibraryItem } from '@/hooks/runware/image-library';


import { Ruler, Hash } from 'lucide-react';

interface ImageSettingsProps {
  image: ImageLibraryItem;
}

// Mode selector component has been removed as it was an artifact

export const ImageSettings: React.FC<ImageSettingsProps> = ({ image }) => {
  return (
    <div className="space-y-3">
      {/* Settings header removed as requested */}
      
      {/* Dimensions & Seed - Modern Design */}
      <div className="flex flex-col gap-2 mb-3">
        {/* Dimensions panel */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-950/40 dark:to-indigo-950/40 rounded-lg p-3 shadow-sm border border-blue-100 dark:border-blue-900/30">
          <div className="flex items-center gap-2 mb-1.5">
            <Ruler size={16} className="text-blue-500 dark:text-blue-400" />
            <span className="text-xs font-medium text-blue-700 dark:text-blue-300">Dimensions</span>
          </div>
          <div className="text-sm font-mono bg-white/70 dark:bg-gray-800/70 rounded px-2 py-1 text-gray-800 dark:text-gray-200 inline-flex items-center justify-center">
            {image.width}×{image.height}
          </div>
        </div>
        
        {/* Seed panel */}
        {image.seed !== undefined && (
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-950/40 dark:to-pink-950/40 rounded-lg p-3 shadow-sm border border-purple-100 dark:border-purple-900/30">
            <div className="flex items-center gap-2 mb-1.5">
              <Hash size={16} className="text-purple-500 dark:text-purple-400" />
              <span className="text-xs font-medium text-purple-700 dark:text-purple-300">Seed</span>
            </div>
            <div className="text-sm font-mono bg-white/70 dark:bg-gray-800/70 rounded px-2 py-1 text-gray-800 dark:text-gray-200 overflow-x-auto whitespace-nowrap max-w-full">
              {image.seed}
            </div>
          </div>
        )}
      </div>
      
      {/* Filter info moved to under description */}
    </div>
  );
};
